// 语言列表
export const apiGetLangList = (pageNum: number, pageSize: number, search: Partial<LyBase.Lang>) => {
    return usePost<LyBase.LangList>("order/mtl/list", {
        pageNum,
        pageSize,
        ...search,
    })
}

// 添加语言
export const apiAddLang = (data: Record<string, any>) => {
    return usePost<null>("order/mtl/add", data)
}

// 添加语言
export const apiEditLang = (data: Record<string, any>) => {
    return usePost<null>("order/mtl/update", data)
}

// 查询语言
export const apiGetLang = () => {
    return useGet<Record<LyBase.Lang["msgCode"], LyBase.Lang>>("order/mtl/webList", {
        sysType: "diy",
    })
}

// 查询语言
export const apiGetLangByType = (lang: "cn" | "en" | "tw", sysType: string = "diy") => {
    return useBaseGet<Record<LyBase.Lang["msgCode"], string>>("api/order/mtl/webListLang", {
        sysType,
        lang,
    })
}

// 根据ID查询
export const apiGetLangById = (msgCode: string) => {
    return useGet<LyBase.Lang>("order/mtl/singleQuery", {
        id: msgCode,
    })
}

export const apiSetAPiLang = (lang: string) => {
    return useGet<null>("order/mtl/setting", {
        lang,
    })
}
